/*
poornima   9/19/2022   2700912712 Fixed GAL- 122,127,128,130,161,163,170,171,173 bugs
Ravi       10/10/2022  2701012930 fixed sorting issue in BRE
dilip      10/10/2022  3075154998 changed Visibility To Datausage icon
dilip      10/10/2022  3075154998 visbility icon changed to Datausage
saikrishna 10/12/2022  3075154998 Print_Payload_changes ,FormulaRuleGroup_payload
ashraf     10/13/2022  2701127043_2698966688  fixed filter and formula rule group, communication history bug fixes
 Suresh Peddavoora  10/26/2022 3075154998 Added outlined icons in Actions column in Rule Group SearchTable .
 akhila 10/27/2022 2701127043  bre UX Changes
 Dilip  31/10/2022 2701012930  added clickable link functionality to Rule Group code
 Ashraf  11/01/2022 2701012930  reordered icons
 Ashraf 11/01/2022 2701012930 disabled download buttons when there are no records
lalitha 11/01/2022 2701012930 added span element in column link
saikrishna 11/03/2022 3075154998 label changes in table
saikrishna 11/03/2022 2701012930 changed paginationOptions
Prakash 11/03/2022 3075154998 Removed unnecessary classes in table.
Dilip 11/03/2022 2701012930 Added rule group in delete popup
saikrishna 11/04/2022 2701012930 Added props
saikrishna 11/04/2022 2701012930 Added isCopy in useEffect
Dilip 11/04/2022 2701012930 Changed message in delete popup
Sohel 11/05/2022 2701012930 rename download configurations
Sohel 11/08/2022 2701012930 prepopulate formula code
Dilip 11/14/2022 2701012930  Enable delete usage popup
Ashraf 11/14/2022 2701012930 fixed bre role issue
Ashraf 11/14/2022 2701012930 Added status column in search table.
Ashraf 11/19/2022 2701012930 Added copy functionality
Akhila 11/21/2022 2701012930 addAccount props pass
Sohel 11/21/2022 2701012930 props pass
Sohel 11/22/2022 2701012930 formula Rule Group Table changes
Ashraf 11/23/2022 2701012930 fixed selection of rule code for different modules
Ashraf 11/23/2022 2701012930 added column formula type
kavya9reddy 11/30/2022 2701012930 added isDraft in search download configuration
Akhila 11/30/2022 2701012930 bugfixed delete success toastMsg
Lalitha  11/30/2022 2701012930 Rename Copy Fliter Rule Group to Copy Formula Rule Group
Suresh Peddavoora 12/01/2022 2701012930 Added ClassName for Draft Status and Removed Inline Styles
Dilip 12/05/2022  2701012930 Removed unecesarry console.log statements
Sohel  12/05/2022 2701012930 Added Edit Icon and border to code
lalitha 12/07/2022 2701012930 added Created By payload
Lalitha 12/08/2022 2701012930 Rename Formula to Data Calculation
Rajesh 12/08/2022 2701012930 changed dialog box size
Ravi 12/08/2022 2701012930 Fixed systemNotes popup
Ashraf 12/09/2022 2701012930 fixed toast message issue
Akhila 12/09/2022 2701012930 fixed session saerch issue
lalitha 12/09/2022 2701012930 Added Created Date column and payload
kavya9reddy 12/12/2022 2701012930 Renamed the label in copy,delete
Ashraf 12/14/2022 2701012930 fixed role access
kavyareddy 12/15/2022 2701012930 Added role disable condition
Ashraf 15/16/2022 2701012930 fixed role access
akhila 12/18/2022  2701012930 changed Delete popup label
dilip 12/20/2022  2701012930 changed Delete popup title and override popup title
akhila 12/21/2022 2701012930 integrated returnType dropdown
lalitha 12/22/2022 2701012930 changed Copy poup title
akhila 12/23/2022 2701012930 fixed dataCalculation code uppercase issue
dilip 12/26/2022 2701012930 added createBy and createdDate in Download Configuration API.
akhila 12/26/2022 2701012930 fixed returnType in downloadConfigurationUsage
Raghu 12/26/2022 2701012930 Added Dialog Component
sai krisha 30/12/2022 2701012930 add code description values
Ashraf 01/02/2022 2701012930 renamed usage header title
saikrishna 1/2/2023 2701012930 changed the download usage payload
lalitha 1/10/2023 2701012930 fixed download configuration issue
saikrishna 01/10/2023 2701012930  updated download configuration payload
Akhila 02/01/2023 2701012930 bugFixed for trigger addAction prepopulation issue of return type
Dilip 02/09/2023 3225736869 added created by dropdown
Akhila 02/08/2023 2701012930 bugFixed return type in data Calculation table issue fixed
Raghu 02/21/2023 2701012930 changed table buttons color
Raghu 02/23/2023 2701012930 fixed new ui changes
Akhila 02/24/2023 2701012930 implemented preview file functionality in download configuration
Dilip 02/28/2023 2701012930 Fixed Sorting issue
Dilip 02/28/2023 2701012930 payload change
Akhila 03/01/2023 2701012930  Added loader and download toast message for preview File
Rohini 03/14/2023 2701012930  Added class name for table pagination
Suresh Peddavoora 03/15/2023 2701012930 Added Dropdown menu in Action Column in table
Suresh Peddavoora 03/16/2023 2701012930 Added test menu in Action Column in table
Raghu 046/04/2023 2701012930 added add icon
suresh peddavoora 04/06/2023 2701012930 field alignments fixes
Sohel  04/25/2023 2701127043 Added Data Calculation Field
Ravi 05/31/2023 2701012930 changed delete popup message
Akhila 06/07/2023 2701012930 added breadcrum code and description
Akhila 06/08/2023 2698948956 created date change to date created field and column
uday  19/10/2023 2698948956 fixed add table scroll issue
Sohel 11/30/2023 2698948956 Reports Fixed Data Calculation Reset Issue
Gireesh 12/11/2023 2700912712 removed uppercase for Data Calculation Code validation in table column
*/
import React, {createRef, useEffect, useState, useRef} from 'react';
// import MaterialTable from "material-table";
import {Button, Grid, TablePagination} from '@material-ui/core';
import {tableIcons} from '../../../../../components/TableIcons';
import {httpPaginationPost, httpPaginationDelete} from '../../../../../util/Rest';
import {useDispatch, useSelector} from 'react-redux';
import {
  fetchRuleGroup,
  resetMessage,
  ResetMessage as resetMsg,
  fetchError,
  fetchFormulaUsage,
  postFormulaRuleGroup,
  resetCopyFormula,
  fetchAllCodeAndDisplayName,
  fetchDeleteSuccess,
  resetConfigUrl,
  resetDockey,
} from '../../../../../redux/reducers/BRE/AddRuleGroup';
import {
  defaultRows,
  tablePageRows,
} from '../../../../../constants/ReusableTablePagination';
import DeleteTableRecordPopup from '../../../../../util/DeleteTableRecordPopup';
import PageLoader from '../../../../../components/PageLoader';
import {
  postPrintUsage,
  resetPrintUsageData,
} from './../../../../../redux/reducers/printUsage/index';
import {resetRuleGroupPrintStatus} from '../../../../../redux/reducers/BRE/AddRuleGroup';
import {ErrorSnackbar, SuccessSnackbar} from './../../../../../components/CustomSnackBar/index';
import OverrideRule from './../../../../../components/OverrideRule';
import GuiTable from '../../../../../components/FormComponents/GuiTable';
import {makeStyles} from '@material-ui/core';
import UsageMessage from '../../../../../util/UsageMessage';
import DialogBox from '../../../../../components/DialogBox/index';
import CopyFormula from './CopyFormula';
import FormulaNote from './FormulaNotes';
import moment from 'moment';
import {downloadButton} from '../../../../../util/Content';
import {fetchCreatedByDropDownData} from '../../../../../redux/reducers/ReportMaster';
import PreviewFileDialog from '../../../../../util/PreviewFileDialog';
import axios from 'axios';
import {resetDownloadMsg} from '../../../../../redux/reducers/PreviewFileData';

import SaveIcon from '@material-ui/icons/Save';
import ActionMenuItem from '../../../../../util/ActionMenuItem';
import {MTableToolbar} from 'material-table';
import AddIcon from '@material-ui/icons/AddOutlined';
import {getFields} from '../../../Reports/AddReport/Components/utils';
export default function RuleGroupSearchTable({
  setValue,
  setFieldRowData,
  searchData,
  setBreCode,
  submit,
  setResetData,
  setSubmit,
  dataReset,
  handleClose,
  setUsageState,
  usageState,
  setDeleteUsage,
  userMetrixDelete,
  isDelete,
  setIsDelete,
  isUsage,
  setIsUsage,
  setRowSelected,
  setUserMetrixDelete,
  addAccount,
  setOpenFormulaCode,
  setSelectedFormulaCode,
  addAction,
  fieldRowData,
  setEditExisting,
  isReports,
  setTempSelectedRows,
  tempSelectedRows,
  setReportFieldValue,
  reportSelectedRows,
  setReportSelectedRows,
  tempUnCheckedRef,
  isReportsFilter,
  rules,
  addAccountUpdate,
  selectedGlobalField,
}) {
  const {roleData} = useSelector(({role}) => role);
  const roleDataAccessDc = roleData?.window?.['Data Calculations']?.DC;
  const {
    copyErrorMsg,
    copySuccessMsg,
    copyId,
    copyFormulaStatus,
    isLoading,
    printStatus,
    errorMsg,
    formulaUsageResponse,
    downloadSuccessMessage,
    configurationUrl,
    dockey,
  } = useSelector(({addRuleGroup}) => addRuleGroup);
  const {searchRuleGroupFieldData} = useSelector(({addEventTactic}) => addEventTactic);
  const [copyFilter, setCopyFilter] = useState(false);
  const [oldFilterCode, setOldFilterCode] = useState('');
  const [codeAndDescription, setCodeAndDescription] = useState({});
  const [isNote, setIsNote] = useState(false);
  const [formulaCodeData, setFormulaCodeData] = useState();
  const queryRef = useRef(null);

  useEffect(() => {
    dispatch(fetchAllCodeAndDisplayName());
  }, []);

  const useStyles = makeStyles((theme) => ({
    'link': {
      // Changed field list code column font color (2700799562)
      color: '#320469 !important',
      borderBottom: '1px solid #000099',
    },
    ' & .MuiSvgIcon-root': {
      backgroundColor: '#320469 !important',
    },
  }));
  const classes1 = useStyles();
  const {
    isLoading: printUsageIsLoading,
    successMsg: printUsageSuccessMsg,
    errorMsg: printUsageErrorMsg,
  } = useSelector(({printusage}) => printusage);
  useEffect(() => {
    if (printUsageSuccessMsg || printUsageErrorMsg) {
      setTimeout(() => {
        dispatch(resetPrintUsageData());
      }, 3000);
    }
  }, [printUsageSuccessMsg, printUsageErrorMsg]);

  useEffect(() => {
    if (copyFormulaStatus === 200) {
      setTimeout(() => {
        copyId && dispatch(fetchRuleGroup(copyId));
        dispatch(resetCopyFormula());
        setValue(1);
        setCopyFilter(false);
      }, 2500);
    }
  }, [copyFormulaStatus]);
  useEffect(() => {
    if (downloadSuccessMessage) {
      setTimeout(() => {
        dispatch(resetRuleGroupPrintStatus());
      }, 1500);
    }
  }, [downloadSuccessMessage]);
  useEffect(() => {
    if (copyErrorMsg || copySuccessMsg) {
      setTimeout(() => {
        dispatch(resetCopyFormula());
      }, 2500);
    }
  }, [copyErrorMsg, copySuccessMsg]);

  const handleCopyFilter = () => {
    setCopyFilter(false);
  };

  const columns = [
    {
      title: 'Data Calculation Name',
      field: 'code',
      render: (rowData) =>
        isReports ? (
          rowData?.code
        ) : (
          <span
            role="button"
            className={classes1.link}
            onClick={() => {
              if (addAccount && !addAction) {
                setSelectedFormulaCode(rowData);
                setOpenFormulaCode(false);
              } else if (
                addAction &&
                Object.keys(searchRuleGroupFieldData).length > 0 &&
                searchRuleGroupFieldData.status
              ) {
                searchRuleGroupFieldData.setFieldValue(
                  searchRuleGroupFieldData.fieldName,
                  {dataCalculation:rowData.code,groupId:rowData.groupId},
                );
                searchRuleGroupFieldData.setShowSearch(false);
              }
              if (!addAccount && !addAction) {
                if (handleClose) {
                  dispatch(fetchRuleGroup(rowData.groupId));
                  handleClose();
                } else {
                  dispatch(fetchRuleGroup(rowData.groupId));
                  setEditExisting(rowData.groupId);
                  setValue(1);
                  setBreCode(rowData.code);
                }
              }
            }}
          >
            {rowData?.code?.replace(/ /g, '\u00a0')}
          </span>
        ),
    },
    // {
    //   title: "Data Calculation Name",
    //   field: "displayName",
    // },
    {
      title: 'Data Calculation Description',
      field: 'description',
      width: '2%',
      headerStyle: {textAlign: 'left', fontSize: 16},
      render: (rowData) => (
        <>
          <div
            style={{
              maxWidth: 500,
              textAlign: 'justify',
              whiteSpace: 'normal',
              wordWrap: 'break-word',
            }}
          >
            {rowData?.description?.replace(/ /g, '\u00a0')}
          </div>
        </>
      ),
    },
    {
      title: 'Data Calculation Type',
      field: 'formulaType',
    },
    {
      title: 'Return Type',
      field: 'returnType',
      width: '2%',
      headerStyle: {textAlign: 'left', fontSize: 16},
      render: (rowData) => (
        <>
          <div
            style={{
              maxWidth: 500,
              textAlign: 'justify',
              whiteSpace: 'normal',
              wordWrap: 'break-word',
            }}
          >
            {rowData.returnType}
          </div>
        </>
      ),
    },
    {
      title: 'Created By',
      field: 'createdBy',
    },
    {
      title: 'Date Created',
      field: 'createdDate',
      render: (rowData) => {
        return rowData?.createdDate ? moment(rowData?.createdDate).format('MM/DD/YYYY') : '';
      },
    },
    {
      title: 'Status',
      field: 'isDraft',
      render: (rowData) =>
        rowData?.isDraft === 'Y' ? (
          <div className="draft-status status">
            <span>Draft</span>
          </div>
        ) : (
          <div className="completed-status status">
            <span>Completed</span>
          </div>
        ),
    },
  ];
  const [countTotal, setCountTotal] = useState(null);
  const tableRef = createRef();
  const dispatch = useDispatch();
  const [arrayLast, setArrayLast] = useState(false);
  const [rows, setRows] = useState(defaultRows);
  const [userData, setUserData] = useState(null);
  const [status, setStatus] = useState(false);
  const {systemsuccessMsg} = useSelector(
    ({systemNotes}) => systemNotes,
  );

  const [loading, setIsLoading] = useState(false);
  const [configOpen, setConfigOpen] = useState(false);
  const [configData, setConfigData] = useState(null);

  const handleConfigClose = () => {
    setConfigOpen(false);
    dispatch(resetConfigUrl());
    dispatch(resetDockey());
    dispatch(resetDownloadMsg());
  };

  useEffect(() => {
    if (configurationUrl) {
      setIsLoading(true);
      async function readData() {
        setConfigOpen(true);
        const data = await axios({
          url: configurationUrl,
          method: 'GET',
        });
        setConfigData(data);
        setIsLoading(false);
      }
      readData();
    }
  }, [configurationUrl]);

  useEffect(() => {
    if (tableRef?.current && submit) {
      Object.keys(searchData).length > 0 ? tableRef.current.onQueryChange() : '';
    }
  }, [submit, searchData]);
  useEffect(() => {
    if (!addAccount && !isReports) {
      usageState && setUsageState(false);
      setRowSelected(false);
    }
  }, []);
  useEffect(() => {
    if (printStatus === 200 || errorMsg) {
      setTimeout(() => {
        dispatch(resetMsg());
      }, 3000);
    }
  }, [printStatus, errorMsg]);
  useEffect(() => {
    tableRef.current.onQueryChange();
    dispatch(fetchCreatedByDropDownData('datacalculation'));
  }, [status]);
  useEffect(() => {
    dataReset && setResetData(null);
  }, []);
  const handleDelete = (rowData) => {
    dispatch(fetchFormulaUsage(rowData.groupId));
    setIsDelete(false);
    setDeleteUsage(true);
    setUserData(rowData);
    // handleDelete(rowData);
  };
  const handleEdit = (rowData) => {
    if (addAccount && !addAction) {
      setSelectedFormulaCode(rowData);
      setOpenFormulaCode(false);
    } else if (
      addAction &&
      Object.keys(searchRuleGroupFieldData).length > 0 &&
      searchRuleGroupFieldData.status
    ) {
      searchRuleGroupFieldData.setFieldValue(searchRuleGroupFieldData.fieldName, rowData.code);
      searchRuleGroupFieldData.setShowSearch(false);
    }
    if (!addAccount && !addAction) {
      if (handleClose) {
        dispatch(fetchRuleGroup(rowData.groupId));
        handleClose();
      } else {
        dispatch(fetchRuleGroup(rowData.groupId));
        setEditExisting(rowData.groupId);
        setValue(1);
        setBreCode(rowData.code);
      }
    }
  };
  const handleCopy = (rowData) => {
    setCopyFilter(true);
    setOldFilterCode(rowData?.code);
    setCodeAndDescription(rowData);
  };
  const handleUsage = (rowData) => {
    setDeleteUsage(false);
    setFieldRowData(rowData);
    dispatch(fetchFormulaUsage(rowData.groupId));
  };
  const handleCloseDialog = () => {
    setIsDelete(false);
    setIsNote(false);
    setTimeout(() => {
      setUserMetrixDelete(false);
    }, 1000);
  };
  const handleNotes = (rowData) => {
    setFormulaCodeData(rowData);
    handleNote();
  };
  const handleNote = () => {
    setIsNote(true);
  };

  const handleSubmit = () => {
    setStatus(true);
    new Promise((resolve, reject) => {
      httpPaginationDelete(`rules/delete/formularulegroup/${userData.groupId}`)
        .then((response) => {
          if (response?.data?.status === 400) {
            setStatus(false);
            dispatch(fetchError(response));
            handleCloseDialog();
            setTimeout(() => {
              dispatch(resetMessage());
            }, 2000);
          }
          if (response?.status === 200) {
            setStatus(false);
            resolve();
            dispatch(fetchDeleteSuccess(response));
            handleCloseDialog();
            setTimeout(() => {
              dispatch(resetMessage());
            }, 2000);
          } else {
            reject(new Error());
            dispatch(fetchError(response));
            setStatus(false);
            handleCloseDialog();
            setTimeout(() => {
              dispatch(resetMessage());
            }, 2000);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    });
  };

  const handleDeleteUsage = () => {
    if (isDelete && userMetrixDelete) {
      // setFieldRowData(deleteRowInfo);
      // setValue(2);
      setIsUsage(true);
      setIsDelete(false);
      setTimeout(() => {
        setUserMetrixDelete(false);
      }, 1000);
    } else {
      handleSubmit();
    }
  };
  const SearchSessionDataCalculations = JSON.parse(sessionStorage.getItem('DataCalculations'));
  if (SearchSessionDataCalculations && !submit && !isReports && !isReportsFilter && !addAction) {
    searchData = SearchSessionDataCalculations;
  }
  return (
    <>
      <PreviewFileDialog
        open={configOpen}
        dialogClose={handleConfigClose}
        fileUrl={configurationUrl}
        configData={configData}
        dockey={dockey}
        moduleName={'Data Calculations'}
      />
      <DialogBox
        open={copyFilter}
        dialogClose={handleCopyFilter}
        title="Copy Data Calculation "
        maxWidth="md"
        hideFooter={true}
      >
        <CopyFormula oldFilterCode={oldFilterCode} codeAndDescription={codeAndDescription} />
      </DialogBox>
      <DeleteTableRecordPopup
        open={isDelete}
        dialogClose={handleCloseDialog}
        title="Delete Data Calculation"
        value={
          userMetrixDelete ? (
            <UsageMessage value={'Data Calculation'} />
          ) : (
            `Are you sure you want to delete the ${userData?.code?.replace(/ /g, '\u00a0')} Data Calculation ?`
          )
        }
        buttonCondition={userMetrixDelete}
        handleSubmit={handleDeleteUsage}
      />
      <OverrideRule
        dialogTitle="Data Calculation Usage"
        dialogOpen={isUsage}
        dialogClose={() => setIsUsage((state) => !state)}
        title={`${userData?.code || ''} - ${
          userData?.description || ''
        } Data Calculation has been used in the following places.`}
        data={formulaUsageResponse?.placeResponse}
        isOverRide={false}
      />
      <DialogBox
        open={isNote}
        dialogClose={handleCloseDialog}
        title="Data Calculation Notes"
        maxWidth="lg"
      >
        <FormulaNote formulaCodeData={formulaCodeData} />
      </DialogBox>
      <Grid item xs={12}>
        <div
          className={
            addAccount ?
              `custom-table custom-toolbar-icons custom-actions-icon global-field-table new-standard-textfields tablescroll-block` :
              `custom-table custom-toolbar-icons custom-actions-icon global-field-table new-standard-textfields actions-dropdown-table tablescroll-block`
          }
        >
          <GuiTable
            title={''}
            columns={columns}
            icons={tableIcons}
            tableRef={tableRef}
            onSelectionChange={(rows, row) => {
              if (row?.tableData?.checked) {
                if (setReportSelectedRows && reportSelectedRows) {
                  if (tempSelectedRows) {
                    const arr = [...tempSelectedRows].filter((el) => el.tableData.checked);
                    arr.push({
                      ...row,
                      tableData: {...row.tableData, id: row.fieldName + row.repositoryName},
                      ...(!isReportsFilter && getFields(row)),
                      // processorFieldType: "DB Field",
                      // dataType: row.fieldType,
                      fieldName: row.code,
                      repositoryName: 'DATA CALCULATION FIELD',
                      fieldType: row.returnType,
                    });
                    setTempSelectedRows(arr);
                  }
                }
                if (rules && isReportsFilter) {
                  if (row?.tableData?.checked) {
                    const arr = [...tempSelectedRows];
                    arr.push({
                      ...row,
                      tableData: {...row.tableData, id: row.fieldName + row.repositoryName},
                    });
                    setTempSelectedRows(arr);
                  }
                }
              } else {
                if (isReports) {
                  tempUnCheckedRef.current.push(row);
                  const updatedRows = [...tempSelectedRows]
                    .filter(
                      (ele) =>
                        ele?.fieldName + ele?.repositoryName !==
                        row?.fieldName + row?.repositoryName,
                    )
                    .map((ele) => {
                      return {
                        ...ele,
                        tableData: {...ele.tableData, id: ele.fieldName + ele?.repositoryName},
                      };
                    });
                  setTempSelectedRows(updatedRows);
                }
                if (rules && isReportsFilter) {
                  const updatedRows = [...tempSelectedRows]
                    .filter(
                      (ele) =>
                        ele?.fieldName + ele.repositoryName !== row?.fieldName + row.repositoryName,
                    )
                    .map((ele) => {
                      return {
                        ...ele,
                        tableData: {...ele.tableData, id: ele.fieldName + ele.repositoryName},
                      };
                    });
                  setTempSelectedRows(updatedRows);
                }
              }
            }}
            data={(query) =>
              new Promise((resolve) => {
                const url = `rules/search/all`;
                const bodyObj = {
                  code: searchData?.code ? searchData.code : '',
                  displayName: searchData?.displayName ? searchData?.displayName : '',
                  description: searchData?.description ? searchData.description : '',
                  limit: query.pageSize ? query.pageSize : null,
                  returnType: searchData?.returnType?.valueCode ?
                    searchData.returnType?.valueCode :
                    '',
                  formulaType: searchData?.formulaType?.value ? searchData.formulaType?.value : '',
                  isDraft: isReports ? 'N' : searchData?.status?.key ? searchData.status?.key : '',
                  ruleType: 'FormulaRuleGroup',
                  createdBy: searchData?.createdBy?.userLoginName ?
                    searchData?.createdBy?.userLoginName :
                    '',
                  createdDate: searchData?.createdDate ?
                    moment(searchData?.createdDate).format('MM/DD/YYYY') :
                    '',
                  page: submit ?
                    1 :
                    arrayLast && query?.page >= 1 ?
                      query.page :
                      arrayLast ?
                        (query.page <= 1 && query.page + 1) || query.page - 1 :
                        query.page + 1,
                  orderBy: query.orderBy && query.orderBy.field ? query.orderBy.field : '',
                  orderDirection: query?.orderDirection ? query?.orderDirection : '',
                };
                if (addAction && searchRuleGroupFieldData) {
                  bodyObj['returnType'] = searchRuleGroupFieldData.returnType;
                }
                if (addAccountUpdate) {
                  bodyObj['returnType'] = selectedGlobalField.fieldType ||'';
                }
                queryRef.current = query;
                // setOrder({
                //   orderBy: query.orderBy && query.orderBy.field ? query.orderBy.field : "",
                //   orderDirection: query?.orderDirection ? query?.orderDirection : "",
                // });
                if (!searchData) {
                  resolve({
                    data: [],
                    page: 0,
                    totalCount: 0,
                  });
                } else {
                  httpPaginationPost(url, bodyObj)
                    .then((response) => {
                      if (response?.status === 200) {
                        const data = response.data.response.resultObject;
                        const newData =
                          data?.length > 0 ?
                            data?.map((el) => {
                              return {
                                ...el,
                                fieldName: el.code,
                                repositoryName: 'DATA CALCULATION FIELD',
                                fieldType: el.returnType,
                                fieldLabel: el.code,
                              };
                            }) :
                            [];
                        const newObj = {};
                        if (reportSelectedRows) {
                          [...reportSelectedRows, ...tempSelectedRows].forEach((el) => {
                            if (!newObj[el.fieldName + el.repositoryName]) {
                              newObj[el.fieldName + el.repositoryName] = el;
                            }
                          });
                        }
                        const mapData =
                          newData?.length > 0 ?
                            newData?.map((elem) => {
                              if (newObj[elem.fieldName + elem.repositoryName]) {
                                return {
                                  ...elem,
                                  tableData: {...elem.tableData, checked: true},
                                };
                              } else {
                                return {
                                  ...elem,
                                  tableData: {...elem.tableData, checked: false},
                                };
                              }
                            }) :
                            [];
                        resolve({
                          data: isReports ? mapData : data.length > 0 ? data : [],
                          page: response.data.response.page - 1,
                          totalCount: response.data.response.count,
                        });
                        setCountTotal(response.data.response.count);
                        setArrayLast(data.length === 1);
                        setSubmit(false);
                      } else {
                        resolve({
                          data: [],
                          page: 0,
                          totalCount: 5,
                        });
                        dispatch({
                          type: 'FETCH_ERROR',
                          payload: response && response.message ? response.message : null,
                        });
                      }
                    })
                    .catch((response) => {
                      resolve({
                        data: [],
                        page: 0,
                        totalCount: 5,
                      });
                      dispatch({
                        type: 'FETCH_ERROR',
                        payload: response && response.message ? response.message : null,
                      });
                    });
                }
              })
            }
            options={{
              search: false,
              pageSize: rows,
              toolbarButtonAlignment: 'left',
              showTextRowsSelected: false,
              showSelectAllCheckbox: false,
              emptyRowsWhenPaging: false,
              selection: isReports,
              headerStyle: {
                fontWeight: 'bold',
              },
              toolbar: !addAccount && !isReports,
            }}
            // actions={
            //   addAccount
            //     ? []
            //     : [
            //       {
            //         icon: () => (
            //           <>
            //             <Button
            //               type="button"
            //               variant="outlined"
            //               className={`search-btn`}
            //               disabled={!roleDataAccessDc?.add}
            //             >
            //               Add Data Calculation
            //             </Button>
            //           </>
            //         ),
            //         disabled: !roleDataAccessDc?.add,
            //         isFreeAction: true,
            //         onClick: (event) => {
            //           setValue(1);
            //         },
            //       },
            //       !handleClose && {
            //         icon: () => <EditOutlinedIcon />,
            //         tooltip: "Edit",
            //         disabled: !roleDataAccessDc?.edit,
            //         onClick: (event, rowData) => {
            //           if (addAccount && !addAction) {
            //             setSelectedFormulaCode(rowData);
            //             setOpenFormulaCode(false);
            //           } else if (
            //             addAction &&
            //             Object.keys(searchRuleGroupFieldData).length > 0 &&
            //             searchRuleGroupFieldData.status
            //           ) {
            //             searchRuleGroupFieldData.setFieldValue(
            //               searchRuleGroupFieldData.fieldName,
            //               rowData.code
            //             );
            //             searchRuleGroupFieldData.setShowSearch(false);
            //           }
            //           if (!addAccount && !addAction) {
            //             if (handleClose) {
            //               dispatch(fetchRuleGroup(rowData.groupId));
            //               handleClose();
            //             } else {
            //               dispatch(fetchRuleGroup(rowData.groupId));
            //               setEditExisting(rowData.groupId);
            //               setValue(1);
            //               setBreCode(rowData.code);
            //             }
            //           }
            //         },
            //       },
            //       !handleClose && {
            //         icon: () => (
            //           <>
            //             <FileCopyOutlinedIcon className={classes.copyButtonroot} />
            //           </>
            //         ),
            //         tooltip: "Copy",
            //         position: "row",
            //         disabled: !roleDataAccessDc?.add,
            //         onClick: (event, rowData) => {
            //           // setValue(1);
            //           // dispatch(fetchRuleGroup(rowData.groupId));
            //           // setResetData(rowData.groupId);
            //           setCopyFilter(true);
            //           setOldFilterCode(rowData?.code);
            //           setCodeAndDescription(rowData);
            //         },
            //       },
            //       !handleClose && {
            //         icon: () => <DataUsageIcon className={classes.copyButtonroot} />,
            //         tooltip: "Usage",
            //         onClick: (event, rowData) => {
            //           setDeleteUsage(false);
            //           setFieldRowData(rowData);
            //           dispatch(fetchFormulaUsage(rowData.code));
            //         },
            //       },
            //       !handleClose && {
            //         icon: () => (
            //           <>
            //             <DeleteOutlineOutlinedIcon className={classes.copyButtonroot} />
            //           </>
            //         ),
            //         disabled: !roleDataAccessDc?.delete,
            //         tooltip: "Delete",
            //         onClick: (event, rowData) => handleDelete(rowData),
            //       },
            //       !handleClose && {
            //         icon: () => <DescriptionOutlinedIcon className={classes.copyButtonroot} />,
            //         tooltip: "Notes",
            //         onClick: (event, rowData) => {
            //           setFormulaCodeData(rowData?.code);
            //           handleNote();
            //         },
            //       },
            //     ]
            // }
            actions={
              addAccount || isReports ?
                [] :
                [
                  {
                    icon: () => <SaveIcon />,
                    tooltip: 'Save User',
                    onClick: (event, rowData) => console.log(rowData, 'rowData'),
                  },
                ]
            }
            components={{
              Pagination: (props) => (
                <div className="global-field-table-footer pagination-block ">
                  <div className="mt-2">
                    {!addAccount && !isReports && (
                      <>
                        <Button
                          type="button"
                          variant="outlined"
                          className={`mx-1 search-btn`}
                          disabled={Boolean(countTotal === 0)}
                          // isFreeAction= true,
                          onClick={(event) => {
                            dispatch(
                              postPrintUsage({
                                baseCategory: '',
                                code: searchData?.code ? searchData.code : '',
                                description: searchData?.description ? searchData.description : '',
                                displayName: searchData?.displayName ? searchData?.displayName : '',
                                fileType: '',
                                recordFormatType: '',
                                returnType: searchData?.returnType?.valueCode ?
                                  searchData.returnType?.valueCode :
                                  '',
                                isDraft: searchData?.status?.key ? searchData.status?.key : '',
                                sourceType: 'DATA CALCULATION',
                                search: '',
                                frameworkUsageOrderBy: '',
                                frameworkUsageOrderDerection: '',
                                fieldListOrderBy:
                                  queryRef.current.orderBy && queryRef.current.orderBy.field ?
                                    queryRef.current.orderBy.field :
                                    '',
                                fieldListOrderDerection: queryRef.current?.orderDirection ?
                                  queryRef.current?.orderDirection :
                                  '',
                                category: '',
                                fieldName: '',
                                repositoryDescription: '',
                                repositoryName: '',
                                repositoryType: '',
                                createdBy: searchData?.createdBy?.userLoginName ?
                                  searchData?.createdBy?.userLoginName :
                                  '',
                                createdDate: searchData?.createdDate ?
                                  moment(searchData?.createdDate).format('MM/DD/YYYY') :
                                  '',
                              }),
                            );
                          }}
                        >
                          Download Configuration Usage
                        </Button>
                        <Button
                          type="button"
                          variant="outlined"
                          className={`mx-1 search-btn`}
                          disabled={Boolean(countTotal === 0)}
                          onClick={() => {
                            dispatch(
                              postFormulaRuleGroup({
                                code: searchData?.code ? searchData.code : '',
                                displayName: searchData?.displayName ? searchData?.displayName : '',
                                description: searchData?.description ? searchData.description : '',
                                returnType: searchData?.returnType?.valueCode ?
                                  searchData.returnType?.valueCode :
                                  '',
                                ruleType: 'FormulaRuleGroup',
                                orderBy:
                                  queryRef.current.orderBy && queryRef.current.orderBy.field ?
                                    queryRef.current.orderBy.field :
                                    '',
                                orderDirection: queryRef.current?.orderDirection ?
                                  queryRef.current?.orderDirection :
                                  '',
                                isDraft: searchData?.status?.key ? searchData.status?.key : '',
                                formulaType: searchData?.formulaType?.value ?
                                  searchData.formulaType?.value :
                                  '',
                                createdBy: searchData?.createdBy?.userLoginName ?
                                  searchData?.createdBy?.userLoginName :
                                  '',
                                createdDate: searchData?.createdDate ?
                                  moment(searchData?.createdDate).format('MM/DD/YYYY') :
                                  '',
                                formulaRuleGroupId : '',
                              }),
                            );
                          }}
                        >
                          {downloadButton}
                        </Button>
                      </>
                    )}
                  </div>
                  <div>
                    <TablePagination
                      {...props}
                      SelectProps={{
                        inputProps: {'aria-label': 'Rows per screen'},
                      }}
                      labelRowsPerPage={'Rows per screen:'}
                      rowsPerPageOptions={tablePageRows}
                      onChangeRowsPerPage={(event) => {
                        props.onChangeRowsPerPage(event);
                        setRows(event.target.value);
                      }}
                    />
                  </div>
                </div>
              ),
              Action: (props) => (
                <ActionMenuItem
                  {...props}
                  handleDelete={handleDelete}
                  handleEdit={handleEdit}
                  handleNotes={handleNotes}
                  handleCopy={handleCopy}
                  handleUsage={handleUsage}
                  hiddenMenu={{
                    edit: false,
                    run: true,
                    copy: false,
                    hiddenDelete: false,
                    notes: false,
                    execution: true,
                    usage: false,
                    user: true,
                    password: true,
                    test: true,
                  }}
                  disableMenu={{
                    disableEdit: !roleDataAccessDc?.edit,
                    disableRun: false,
                    disableCopy: !roleDataAccessDc?.add,
                    disableDelete: !roleDataAccessDc?.delete,
                    disableExecution: false,
                    disableNotes: false,
                    disableUsage: false,
                    disableUser: false,
                    disablePassword: false,
                    disableTest: false,
                  }}
                />
              ),
              Toolbar: (props) => (
                <div>
                  <MTableToolbar {...props} />
                  <div>
                    {!addAccount && !isReports && (
                      <Button
                        type="button"
                        variant="outlisetOpenned"
                        className={`mx-1 search-btn`}
                        isFreeAction={true}
                        disabled={!roleDataAccessDc?.add}
                        onClick={(event) => {
                          setValue(1);
                        }}
                        startIcon={<AddIcon />}
                      >
                        Add Data Calculation
                      </Button>
                    )}
                  </div>
                </div>
              ),
            }}
          />
          {(isLoading || printUsageIsLoading || loading) && <PageLoader />}
          {(printUsageErrorMsg || copyErrorMsg) && (
            <ErrorSnackbar errorMsg={printUsageErrorMsg || copyErrorMsg} />
          )}
          {(printUsageSuccessMsg ||
            copySuccessMsg ||
            systemsuccessMsg ||
            downloadSuccessMessage) && (
            <SuccessSnackbar
              successMsg={
                systemsuccessMsg || printUsageSuccessMsg || copySuccessMsg || downloadSuccessMessage
              }
            />
          )}
        </div>
      </Grid>
    </>
  );
}
